import React from 'react';
import { BrowserRouter } from 'react-router-dom';
import { ThemeProvider } from '@mui/material/styles';
import { Provider } from 'react-redux';
import CssBaseline from '@mui/material/CssBaseline';
import theme from './theme';
import { store } from './redux/store';
import { NotificationProvider } from './contexts/NotificationContext';
import { FirebaseProvider } from './contexts/FirebaseContext';
import { SubscriptionProvider } from './contexts/SubscriptionContext';
import { EventProvider } from './contexts/EventContext';
import Routes from './routes';
import SubscriptionNotifications from './components/SubscriptionNotifications';

const App: React.FC = () => {
  return (
    <Provider store={store}>
      <ThemeProvider theme={theme}>
        <CssBaseline />
        <SubscriptionNotifications />
        <BrowserRouter>
          <FirebaseProvider>
            <SubscriptionProvider>
              <NotificationProvider>
                <EventProvider>
                  <Routes />
                </EventProvider>
              </NotificationProvider>
            </SubscriptionProvider>
          </FirebaseProvider>
        </BrowserRouter>
      </ThemeProvider>
    </Provider>
  );
};

export default App;
